<template>
  <div class="right-top-list">
    <div style="position: relative">
      <titleComponent titleName="区域任务时序分析"> </titleComponent>
      <el-radio-group v-model="tabPosition" class="special-radio" size="mini" @input="tabChange">
        <el-radio-button label="top">上报问题</el-radio-button>
        <el-radio-button label="bottom">长期巡查</el-radio-button>
        <el-radio-button label="left">孤寡老人巡查</el-radio-button>
      </el-radio-group>
    </div>
    <div class="center-point" v-if="tabPosition == 'top'">
      <div style="width: 1482px; height: 360px">
        <wgEchart :options="rightTopOneList" id="rightTopOne"></wgEchart>
      </div>
    </div>
    <div class="center-point" v-if="tabPosition == 'bottom'">
      <div style="width: 1482px; height: 360px">
        <wgEchart :options="rightTopTwoList" id="rightTopTwo
        "></wgEchart>
      </div>
    </div>
    <div class="center-point" v-if="tabPosition == 'left'">
      <div style="width: 1482px; height: 360px">
        <wgEchart :options="rightTopThreeList" id="rightTopThree"></wgEchart>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleComponent from "@/pages/patrolScreen/components/title.vue";
import { extendBigScreenSxfxTj } from "@/api/daping.js";
import * as echarts from "echarts";

export default {
  name: "index",
  components: {
    wgEchart,
    titleComponent,
  },
  data() {
    return {
      tabPosition: "top",
      rightTopOneList: {},
      rightTopTwoList: {},
      rightTopThreeList: {}
    };
  },
  mounted() {
    this.extendBigScreenSxfxTj();
  },
  methods: {
    async extendBigScreenSxfxTj() {
      let res = await extendBigScreenSxfxTj();
      if (res.data.code == 200) {
        let data = res.data.data;
        this.optionsListData(data && data.reportSxfx, data && data.handleSxfx);
        this.optionsListDataTwo(data && data.xcSxfx);
        this.optionsListDataThree(data && data.ggrlTaskSxfx, data && data.ggrlAddSxfx);
      }
    },
    optionsListData(reportSxfx, handleSxfx) {
      let dataX = reportSxfx.map(item => item.label);
      let dataY1 = handleSxfx.map(item => item.value);
      let dataY2 = reportSxfx.map(item => item.value);
      this.rightTopOneList = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          top: "20%",
          bottom: "8%",
          containLabel: true,
        },
        legend: {
          data: ["已处置", "上报问题"],
          left: 'center',
          top: 30,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 16,
          },
          itemWidth: 14,
          itemHeight: 7,
          // itemGap: 35
        },
        xAxis: {
          type: "category",
          data: dataX,
          axisLine: {
            lineStyle: {
              color: "#8c9493",
            },
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              fontSize: 16,
              color: "#ADC2D3",
            },
          },
        },

        yAxis: [
          {
            name: "单位：个",
            nameTextStyle: {
              color: "#ADC2D3",
              fontSize: 15,
            },
            type: "value",
            // max: "150",
            position: "left",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#8c9493",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(172, 206, 234, 0.2)",
                type: "dashed",
              },
            },
            axisLabel: {
              textStyle: {
                fontSize: 16,
                color: "#ADC2D3",
              },
            },
          },
        ],
        series: [
          {
            name: "已处置",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#F7B467" },
                { offset: 1, color: "rgba(247,180,103,0.1)" },
              ]),
            },
            data: dataY1,
          },
          {
            name: "上报问题",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00A3FF" },
                { offset: 1, color: "rgba(0,163,255,0.1)" },
              ]),
            },
            data: dataY2,
          },
        ],
      };
    },
    optionsListDataTwo(xcSxfx) {
      let dataX = xcSxfx.map(item => item.label);
      let dataY1 = xcSxfx.map(item => item.value);
      this.rightTopTwoList = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          top: "20%",
          bottom: "8%",
          containLabel: true,
        },
        legend: {
          data: ["巡查数"],
          left: 'center',
          top: 30,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 16,
          },
          itemWidth: 14,
          itemHeight: 7,
          // itemGap: 35
        },
        xAxis: {
          type: "category",
          data: dataX,
          axisLine: {
            lineStyle: {
              color: "#8c9493",
            },
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              fontSize: 16,
              color: "#ADC2D3",
            },
          },
        },

        yAxis: [
          {
            name: "单位：个",
            nameTextStyle: {
              color: "#ADC2D3",
              fontSize: 15,
            },
            type: "value",
            // max: "150",
            position: "left",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#8c9493",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(172, 206, 234, 0.2)",
                type: "dashed",
              },
            },
            axisLabel: {
              textStyle: {
                fontSize: 16,
                color: "#ADC2D3",
              },
            },
          },
        ],
        series: [
          {
            name: "巡查数",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#F7B467" },
                { offset: 1, color: "rgba(247,180,103,0.1)" },
              ]),
            },
            data: dataY1,
          },
          // {
          //   name: "上报问题",
          //   type: "bar",
          //   barWidth: 10,
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //       { offset: 0, color: "#00A3FF" },
          //       { offset: 1, color: "rgba(0,163,255,0.1)" },
          //     ]),
          //   },
          //   data: dataY2,
          // },
        ],
      };
    },
    optionsListDataThree(ggrlTaskSxfx, ggrlAddSxfx) {
      let dataX = ggrlTaskSxfx.map(item => item.label);
      let dataY1 = ggrlTaskSxfx.map(item => item.value);
      let dataY2 = ggrlAddSxfx.map(item => item.value);
      this.rightTopThreeList = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          top: "20%",
          bottom: "8%",
          containLabel: true,
        },
        legend: {
          data: ["任务填报", "自主添加填报"],
          left: 'center',
          top: 30,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 16,
          },
          itemWidth: 14,
          itemHeight: 7,
          // itemGap: 35
        },
        xAxis: {
          type: "category",
          data: dataX,
          axisLine: {
            lineStyle: {
              color: "#8c9493",
            },
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              fontSize: 16,
              color: "#ADC2D3",
            },
          },
        },

        yAxis: [
          {
            name: "单位：个",
            nameTextStyle: {
              color: "#ADC2D3",
              fontSize: 15,
            },
            type: "value",
            // max: "150",
            position: "left",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#8c9493",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(172, 206, 234, 0.2)",
                type: "dashed",
              },
            },
            axisLabel: {
              textStyle: {
                fontSize: 16,
                color: "#ADC2D3",
              },
            },
          },
        ],
        series: [
          {
            name: "任务填报",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#F7B467" },
                { offset: 1, color: "rgba(247,180,103,0.1)" },
              ]),
            },
            data: dataY1,
          },
          {
            name: "自主添加填报",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00A3FF" },
                { offset: 1, color: "rgba(0,163,255,0.1)" },
              ]),
            },
            data: dataY2,
          },
        ],
      };
    },
    tabChange(val) {

    }
  },
};
</script>
<style scoped lang="less">
.right-top-list {
  width: 100%;
  height: 455px;
}
.flex-just {
  display: flex;
  justify-content: space-between;
}
.special-radio {
  position: absolute;
  margin-bottom: 0px !important;
  bottom: 0px;
  right: 10px;
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: linear-gradient(315deg, #006aff 0%, #00a3ff 100%);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #ffffff;
  }
  /deep/ .el-radio-button__inner {
    background: rgba(4, 20, 50, 0.4);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #00a3ff;
  }
}
.center-point {
  width: 1482px;
  height: 360px;
  background: linear-gradient(0, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/right/right-top.vue